module.exports = __webpack_public_path__ + "img/no_pic_male.a3b706c0.png";